import { isUndefined } from 'lodash-es';
import {
  type PropsWithChildren,
  type MouseEvent as ReactMouseEvent,
} from 'react';

import { InteractiveChartTooltip } from '../../../../core/components/tooltip/InteractiveChartTooltip/components/InteractiveChartTooltip.js';
import { VirtualEstimatedSize } from '../../../../core/components/tooltip/InteractiveChartTooltip/types/virtual-estimated-size.js';
import {
  useMousePositionState,
  useTooltipState,
} from '../../../hooks/store/selectors.js';

interface CategoricalBarChartTooltipWrapperProps {
  onMouseLeave: (event?: ReactMouseEvent) => void;
  onScrollContent: (event?: Event) => void;
  estimatedItemSize: VirtualEstimatedSize;
}

const ADJUSTED_LAYOUT_OFFSET = { x: -10, y: 30 };

export const CategoricalBarChartTooltipWrapper = ({
  onMouseLeave,
  onScrollContent,
  estimatedItemSize,
  children,
}: PropsWithChildren<CategoricalBarChartTooltipWrapperProps>) => {
  const { pinnedTooltip } = useTooltipState();
  const mousePosition = useMousePositionState();

  if (isUndefined(mousePosition?.absolute)) {
    return null;
  }

  const { x, y } = mousePosition.absolute;

  return (
    <InteractiveChartTooltip
      position={{
        x: x + ADJUSTED_LAYOUT_OFFSET.x,
        y: y + ADJUSTED_LAYOUT_OFFSET.y,
      }}
      pinned={pinnedTooltip}
      itemSize={estimatedItemSize}
      onMouseLeave={onMouseLeave}
      onScrollContent={onScrollContent}
    >
      {children}
    </InteractiveChartTooltip>
  );
};
